import { NavItem } from '../../core/models/navigation.model';

/** A flattened, searchable representation of a navigable route. */
export interface SearchRoute {
  readonly label: string;
  /** Human-readable breadcrumb (e.g. "Producción › Pedidos"). Empty for top-level items. */
  readonly breadcrumb: string;
  /** Angular router path. */
  readonly route: string;
  readonly icon?: string;
}

/** Strips diacritics and lowercases a string for accent-insensitive comparison. */
export function normalizeText(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

/**
 * Recursively flattens a `NavItem` tree into a list of leaf `SearchRoute`s.
 * Parent items without a `route` are used only as breadcrumb segments.
 */
export function flattenRoutes(
  items: readonly NavItem[],
  parents: readonly NavItem[] = [],
): SearchRoute[] {
  const results: SearchRoute[] = [];

  for (const item of items) {
    if (item.children?.length) {
      results.push(...flattenRoutes(item.children, [...parents, item]));
    } else if (item.route) {
      results.push({
        label: item.label,
        breadcrumb: parents.map((p) => p.label).join(' › '),
        route: item.route,
        icon: item.icon ?? parents[0]?.icon,
      });
    }
  }

  return results;
}
